import React from "react";

// Coin icon components for Gold and Follis currency
export function GoldCoin({ size = 16, className = "" }) {
  return (
    <img 
      src="/gold-coin.png" 
      alt="Gold" 
      className={`inline-block ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function FollisCoin({ size = 16, className = "" }) {
  return (
    <img 
      src="/follis-coin.png" 
      alt="Follis" 
      className={`inline-block ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
